// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__38GH5","clinicsSelect":"styles_clinicsSelect__1s9oX"};